const INFO = {
	main: {
		title: "About Hassan",
		name: "Hassan khalid",
		email: "inbox.hassan@oulook.com",
		logo: "../logo.jpg",
	},

	socials: {
		twitter: "https://twitter.com/",
		github: "https://github.com/Hassan-Khalid",
		linkedin: "https://linkedin.com/in/hassan-khalid-801816170",
		instagram: "https://www.instagram.com/its.hassan.khalid",


	},

	homepage: {
		title: "I’m Hassan Khalid, a Software Engineer based in Pakistan. I design the future through innovative and impactful applications.",
		description:
			"Software Engineer with expertise in React-Native and React.js. I have experience in building scalable, secure and reliable Mobile and Web applications using various frameworks and technologies. I enjoy solving complex problems and learning new skills. I am passionate about creating high-quality code that follows best practices and industry standards. I am always looking for new challenges and opportunities to grow as a developer.",
	},

	about: {
		title: "I’m Hassan Khalid. I live in Pakistan, where I design the future.",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to. If you're interested in any of the projects I've worked on, please feel free to check out the code and suggest any improvements or enhancements you might have in mind. Collaborating with others is a great way to learn and grow, and I'm always open to new ideas and feedback.",
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},

	projects: [

		{
			title: "AI-Powered Operations Software - Mobile",
			description:
			"AI-Powered Operations Software for Multi-Location Excellence Streamline daily execution with intelligent workflows for operations, audits, and training. Improve compliance, elevate team performance, and drive consistency across all locations.",
			logo: "../xenia.png",
			linkText: "Project Website",
			link: "https://www.xenia.team/",
		},

		{
			title: "CarSwitch - Automobile Marketplace - Mobile",
			description:
				"CarSwitch, based in the UAE, simplifies buying and selling used cars by offering a platform with certified pre-owned vehicles, detailed inspections, and transparent pricing. Sellers receive professional photos, advertisements, and negotiation support. Additional services include car inspections, warranties, financing, and insurance assistance, ensuring a hassle-free experience for both buyers and sellers.",
			logo: "../carSwitch.jpeg",
			linkText: "Project Website",
			link: "https://carswitch.com/",
		},
		{
			title: "TcpSoftware - Mobile Clock & Mobile Kiosk",
			description:
				"TCP Software's Mobile Time Clock enables accurate timekeeping from anywhere via mobile devices. Employees can clock in and out, take breaks, change departments, and submit time-off requests. Features include geofencing and geolocation for precise tracking, personalized employee experiences, 24/7 remote access, and automated notifications. This tool ensures efficient time management for mobile and remote teams.",
			logo: "tcpsoftware.jpeg",
			linkText: "Project Website",
			link: "https://tcpsoftware.com/products/time-clocks/mobile-time-clock/",
		},
		{
			title: "HeartBeat Health - Remote Cardiologist consultancy - Mobile",
			description:
			"Heartbeat Health offers virtual-first cardiology services, providing remote cardiovascular care with real-time clinical data and device connectivity. They partner with primary care physicians for same-day diagnostic reads, televisits, and comprehensive care programs to enhance accessibility and patient outcomes.",
			logo: "../HB.jpeg",
			linkText: "Project Website",
			link: "https://www.heartbeathealth.com/",
		},
		{
			title: "InFarmer - Web",
			description:
				"InFarmer provides farmers and agricultural organizations with actionable insights and sustainable farming practices through smart technology. Using remotely sensed data, they monitor farms and crops, offering science-based advisories for sustainable production. InFarmer helps mitigate climate risks and reduce CO2 emissions while also aiding farmers in earning carbon credits. They also offer parametric insurance for financial institutions to manage lending risks.",
			logo: "../infarmer.png",
			linkText: "Project Website",
			link: "https://infarmer.io/",
		},
		{
			title: "Makula",
			description:
				"Makula offers a digital solution for machinery manufacturers, equipment suppliers, and facilities to enhance after-sales service management. Their platform includes work order management, parts and inventory tracking, customer portals, analytics, and preventive maintenance. By digitalizing these processes, Makula helps businesses improve efficiency, reduce downtime, and boost after-sales revenue.",
			logo: "../makula.jpeg",
			linkText: "Project Website",
			link: "https://makula.io",
		},
	],

	workHistory:[
		{
			title:"Sr Software Engineer",
			company:"Makula Techonlogies",
			duration:"Feb 2024 - Present",
			logo:"../company/makula_technology_logo.png"
	}
	]
};

export default INFO;
